/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-10 11:21:23
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-28 11:04:59
 * @FilePath     : /marketing-introduce-ssr/services/activity.ts
 * @Description  : 未添加文件描述
 */
import qs from 'querystring';

import { shareTypeText } from '@/common/enums';
import { sensClickInitiative } from '@/utils/sensors';

import { ORDER_BASE_URL, PAY_BASE_URL, TINMAN_BASE_C_URL } from '../common/const';
import { qsParse } from '../utils';
import { rq } from '../utils/request';

export async function queryPackageWebPage<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'webPage/queryPackageWebPage',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/fe/',
    prefix: '/open/',
    params
  });
}

export async function generateShareQRCode<T>(data?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'activityGroup/generateShareQRCode',
    prefix: '/fe/',
    data,
    method: 'POST'
  });
}

/**
 * 获取活动信息
 * @param url 请求的地址
 * @param params 参数
 * @returns
 */
const dataMemo: any = {};
export async function getByActCode<T>(params?: any, update?: boolean): Promise<RespType<T>> {
  const key = `${params.actCode}_${params.inviteCode}`;
  const data = dataMemo[key];

  if (params.actCode && data && !update) {
    return data;
  }

  let res: any = await rq<RespType<T>>({
    url: 'activity/getByActCode',
    prefix: '/fe/',
    enforcement: true,
    params
  });

  if (res.status > 1000) {
    res = await rq<RespType<T>>({
      url: 'activity/getByActCode',
      prefix: '/open/',
      enforcement: true,
      params
    });

    __store.isLogin = false;
  } else {
    __store.isLogin = true;
  }

  dataMemo[key] = res;
  return res;
}

export async function queryInvitePrizeDetail<T>(data?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/webPage/queryInvitePrizeDetail',
    method: 'POST',
    data
  });
}

export async function generateInviteCode<T>(data?: any, sceneParams?: any): Promise<RespType<T>> {
  const resp = await rq<RespType<T>>({
    url: 'fe/event/generateInviteCode',
    method: 'POST',
    data,
    sceneParams
  });
  // 存储生成海报数据 为公共数据
  if (resp?.code === 'SUCCESS' && resp?.data) {
    __store[`invitePosterData_${data?.posterId || 0}`] = resp?.data;
  }
  return resp;
}

function parseUrlAndKey(url: string, key: string) {
  try {
    const urlObj = qs.parse(url?.split('?')?.[1] || '');
    return urlObj?.[key] || '';
  } catch (error) {
    console.log(error);
    return '';
  }
}

export async function shareEvent<T>(data?: any): Promise<RespType<T>> {
  let markStr = '';
  // 运营活动海报分享 获取分享URL 并解析URL参数 和埋点
  const { sensData = {} } = data;
  try {
    const { scanCodeJumpUrl, scanCodeJumpOriginalUrl, miniAppId, miniAppName } =
      __store?.[`invitePosterData_${data?.eventParam?.posterId || 0}`] || {};

    if (scanCodeJumpUrl) {
      const mark_id = parseUrlAndKey(scanCodeJumpUrl, 'mark_id');
      const sceneLabel = parseUrlAndKey(scanCodeJumpOriginalUrl, 'sceneLabel');
      markStr = mark_id ? `&markId=${mark_id}` : '';
      sensClickInitiative({
        $element_name: '运营活动海报分享',
        activity_id: data?.eventParam?.activityId || '',
        activity_label: '转介绍',
        topic_id: mark_id || miniAppName || '',
        $element_content: data?.eventParam?.posterId || '0',
        topic_name: sceneLabel || '',
        custom_state: shareTypeText[miniAppId] || 'H5领课',

        // 130 海报流量分配新增埋点字段
        activity_lib_name: __store?.posterSensInfo?.actPosterRuleId || '',
        activity_lib_id: __store?.posterSensInfo?.actPosterRoundId || '',
        template_name: __store?.posterSensInfo?.posterPageId || '',
        template_type: __store?.posterSensInfo?.posterTabId || '',
        template_id:
          __store?.posterSensInfo?.posterSourceType === 'POSTER_POOL'
            ? __store?.posterSensInfo?.posterPoolId || ''
            : '',
        scene_type: __store?.posterSensInfo?.posterSourceType || '',

        ...sensData
      });
    }
  } catch (error) {
    console.log(error);
  }

  return rq<RespType<T>>({
    url: `fe/event/shareEvent?classId=${data?.classId || ''}&period=${
      data?.period || ''
    }${markStr}`,
    method: 'POST',
    data
  });
}

export async function getUserPreOrderById<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/fe/preOrder/getUserPreOrderById',
    params
  });
}

export function getWxConfig<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'wxmp/create-signature',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/mall/product/api/fe/',
    prefix: '/mall/product/api/product/open/',
    baseURL: TINMAN_BASE_C_URL,
    params
  });
}

// 查询拼团信息
export function queryCollageData<T>(params = {}, sceneParams?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/fe/webPage/queryCollageData',
    params,
    sceneParams
  });
}

// 发起拼团订单/参团下单
export async function groupBooking<T>(params: any = {}): Promise<RespType<T>> {
  const { oid, aid, channel, channelNo } = qsParse();

  const data = {
    ...(params || {}),
    wechatAppid: aid,
    openid: oid,
    channel,
    channelNo
  };

  return rq<RespType<T>>({
    url: data.groupBookingId ? 'fe/group/groupBookingJoin' : 'fe/group/groupBookingOpen',
    method: 'POST',
    data
  });
}

// 获取支付信息
export async function getWxPayConfig<T>(data: any = {}, inner = true): Promise<OldRespType<T>> {
  return rq<OldRespType<T>>({
    baseURL: PAY_BASE_URL,
    url: inner
      ? '/api/fe/pay/create-wechatOrderJSAPI'
      : '/noRight/api/fe/pay/create-wechat-h5-order',
    method: 'POST',
    data
  });
}

export async function getAddressList<T>() {
  return rq<OldRespType<T>>({
    baseURL: ORDER_BASE_URL,
    url: 'api/fe/address/get-userAddress'
  });
}

// 我的拼团
export function myActivityGroup<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityGroup/myActivityGroup',
    method: 'POST',
    data: params
  });
}

/**
 * @description 拼团订单详情
 * @export
 * @template T
 * @param {number} [groupBookingOrderId=0]
 * @param {number} [preOrderId=0]
 * @return {*}  {Promise<RespType<T>>}
 */
export function detailGroupBookingOrder<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityGroup/detailGroupBookingOrder',
    method: 'POST',
    data: params
  });
}

export function getAddTeacherInfo<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityGroup/getAddTeacherInfo',
    method: 'POST',
    data: params
  });
}

export function queryGroupBookingOrderByGroupBookId<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'webPage/queryGroupBookingOrderByGroupBookId',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/fe/',
    prefix: '/open/',
    params
  });
}

export function getWaitPayGroupUser<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityGroup/getWaitPayGroupUser',
    method: 'POST',
    data: params
  });
}

export function uploadScreenshot<T>(params: any = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `fe/event/uploadScreenshot?classId=${params?.classId || ''}&period=${
      params?.period || ''
    }`,
    method: 'POST',
    data: params
  });
}

/**
 * 上传截图后保存用户收货地址
 * POST /api/boom/user/activities/{activityId}/addresses
 */
export function saveActivityAddress<T>(
  activityId: number | string,
  params: { userAddressId: number | string; scene: string }
): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `/user/activities/${activityId}/addresses`,
    method: 'POST',
    data: {
      activityId,
      ...params
    }
  });
}

// 注册用户ugc风控审核任务
export function registUserUgcCheckTask<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/event/registUserUgcCheckTask',
    method: 'POST',
    data: params
  });
}

// 注册用户ugc风控审核任务
export function queryUserUgcCheckTasks<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/event/queryUserUgcCheckTasks',
    method: 'POST',
    data: params
  });
}

export function queryTeacherReferral<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'open/activity/queryTeacherReferral',
    method: 'POST',
    data: params
  });
}

export function listInviteInfo<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityInviteFriendsToWin/listInviteInfo',
    method: 'POST',
    data: params
  });
}

export function actionReserve<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/reserve/action-reserve',
    method: 'POST',
    data: params,
    sceneParams: {
      scene: 'RESERVE'
    }
  });
}

export function detailReserve<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'reserve/detailReserve',
    authPrefix: '/fe/',
    prefix: '/open/',
    method: 'POST',
    data: params
  });
}

export function getReserve<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'reserve/getReserve',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/fe/',
    prefix: '/open/',
    method: 'POST',
    data: params
  });
}

export function receiveReward<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityLottery/receiveReward',
    method: 'POST',
    data: params
  });
}

export function startLottery<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityLottery/startLottery',
    method: 'POST',
    data: params
  });
}

export function myRewards<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/activityLottery/myRewards',
    method: 'POST',
    data: params
  });
}

export function joinActivity<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/event/clockInJoinActivity',
    method: 'POST',
    data: params
  });
}

/**
 * 海报换一换（6.3.2）
 * GET /activities/{actCode}/poster-candidates
 * 响应结构：{ code, message, data: { posterExtId, activityPosterTabs } }
 * data.activityPosterTabs.size()=1（List 为后续拓展预留）
 * @param actCode 活动编码（path）
 * @param params { posterExtId?, tabId?, posterId?, firstSwap? }
 */
export interface ChangePosterResp {
  code: string;
  message?: string;
  data?: {
    posterExtId?: string;
    activityPosterTabs?: any[];
  };
}

export function changePoster(
  actCode: string,
  params: {
    posterExtId?: string;
    tabId?: string;
    posterId?: string;
    firstSwap?: boolean;
  } = {}
): Promise<ChangePosterResp> {
  return rq<ChangePosterResp>({
    url: `/activities/${actCode}/poster-candidates`,
    params
  });
}

export function getApolloConfig<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/noRight/apollo/get-by-key',
    prefix: '/mall/cashback',
    params,
    baseURL: TINMAN_BASE_C_URL
  });
}

export function queryWeeklyActivityDetail<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/webPage/queryWeeklyActivityDetail',
    method: 'POST',
    data: params
  });
}

export function queryPrizeList<T>(
  activityId: string,
  params = {
    scope: ''
  }
): Promise<RespType<T>> {
  let url = '';
  if (params!.scope === 'REFERRAL_ACTIVITY') {
    url = `fe/activities/${activityId}/prizes`;
  } else {
    url = 'fe/user/prizes';
  }
  return rq<RespType<T>>({
    url,
    params: params!.scope === 'REFERRAL_ACTIVITY' ? params : {}
  });
}

export function generateGroupInviteCode<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'fe/event/group/invite-codes',
    method: 'POST',
    data: params
  });
}

export function myGifts<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `fe/user/recommend-gifts`,
    method: 'GET',
    params
  });
}

export function getProductInfo<T>(
  activityId: string,
  prizePoolId: string,
  productId: string,
  params = {}
): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `fe/user/activities/${activityId}/prize-pools/${prizePoolId}/products/${productId}`,
    method: 'GET',
    params
  });
}

export function receiveGifts<T>(
  activityId: string,
  prizePoolId: string,
  productId: string,
  params = {}
): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `fe/user/activities/${activityId}/prize-pools/${prizePoolId}/products/${productId}/exchange`,
    method: 'POST',
    data: params
  });
}

export function newExchangeGift<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: `/user/prize-exchanges`,
    method: 'POST',
    data: params
  });
}

// 推荐礼引导链接类型
export type RecommendGiftGuidanceType = 'PRIZE_POOL' | 'FRIEND_CARD' | 'REFERRAL_ACTIVITY';

// 推荐礼引导接口返回结构
export interface RecommendGiftGuidanceResp {
  // 是否还有待领取的奖励
  hasPendingReward: boolean;
  // 跳转链接地址，点击后引导用户完成领奖或参与活动
  linkUrl: string;
  // 链接类型：PRIZE_POOL=推荐礼领奖链接, FRIEND_CARD=好友卡领取链接, REFERRAL_ACTIVITY=推荐有礼活动参与/邀请路径链接
  type: RecommendGiftGuidanceType;

  tipsText: string;
}

/**
 * 查询推荐礼引导信息（是否有待领奖励、跳转链接、链接类型）
 * @param params { activityId: 活动ID, prizePoolId?: 奖池ID（成功页额外传递） }
 */
export function queryRecommendGiftGuidance<T>(params = {}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/user/reward-guides',
    method: 'GET',
    params
  });
}
